import { SharedStyles } from '@opencare/shared-styles';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { Skeleton } from 'opencare-crown';

export const Wrapper = styled.div`
  display: grid;
  grid-template-areas:
    'photo clinic-name'
    'photo provider-name'
    'photo address'
    'photo time';
  grid-template-columns: min-content;

  column-gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${BRAND_COLORS.dirtyWhite};
  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
  `)}
`;

const photoStyles = css`
  grid-area: photo;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  object-fit: cover;

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
    width: 40px;
    height: 40px;
    `)}
    `;

export const ProfilePhoto = styled.img`
  ${photoStyles}
  outline: 1px solid ${BRAND_COLORS.stroke};
  outline-offset: 1px;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.TABLET, SCREEN_SIZES.SMALL_DESKTOP, SCREEN_SIZES.DESKTOP],
    css`
      align-self: center;
    `,
  )}
`;

export const ProfilePhotoSkeleton = styled(Skeleton.Avatar)`
  ${photoStyles}
  &.ant-skeleton-element .ant-skeleton-avatar {
    width: 100%;
    height: 100%;
  }
`;

const commonTextStyles = css`
  font-size: 14px;
  line-height: 22px;
`;

const skeletonAttributes = {
  paragraph: { rows: 1 },
  title: false,
};

export const ClinicNameSkeleton = styled(Skeleton).attrs(skeletonAttributes)`
  grid-area: clinic-name;
  ${commonTextStyles}
`;

export const ClinicName = styled.p`
  grid-area: clinic-name;
  ${TYPOGRAPHY.CIRCULAR.bold}
  ${commonTextStyles}
  color: ${BRAND_COLORS.black};
`;

const BodyText = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.base}
  ${commonTextStyles}
  color: ${BRAND_COLORS.darkGray};
`;

export const ClinicNameSecondary = styled(BodyText)`
  grid-area: provider-name;
`;

export const ClinicAddressSkeleton = styled(Skeleton).attrs(skeletonAttributes)`
  grid-area: address;
  ${commonTextStyles}
`;

export const ClinicAddress = styled(BodyText)`
  grid-area: address;
`;

export const AppointmentTime = styled.p`
  grid-area: time;
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  color: ${SharedStyles.COLOR.TEXT.PRIMARY.HOVER};
`;

